export default "__VITE_ASSET__BQ5H35lx__"